import React from 'react';
import { StudyGuideMatterRow } from './study-guide-matter-row';
import { StudyGuideMatterCard } from './study-guide-matter-card';
import { Table, TableBody, TableHeaderWrapper, TableNoData } from '@/components/ui/table';
import { EmptyState } from '@/components/custom/empty-state';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideMatterDataGrid({ data }) {
  const playful = usePlayfulStudent();
  const TABLE_HEAD = [{ label: 'Matéria' }, { label: 'Submatéria' }, { label: '', width: 160 }, { label: 'Ações', width: 160 }];

  if (playful) {
    if (!data?.length) {
      return (
        <EmptyState
          variant="plain"
          type="data"
          title="Sem matérias"
          text="Adicione alguma matéria"
        />
      );
    }

    return (
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {data.map(matter => (
          <StudyGuideMatterCard
            matter={matter}
            key={matter.id}
          />
        ))}
      </div>
    );
  }

  return (
    <Table className="min-w-[800px]">
      <TableHeaderWrapper tableHead={TABLE_HEAD} />

      <TableBody>
        {data?.map(matter => (
          <StudyGuideMatterRow
            matter={matter}
            key={matter.id}
          />
        ))}

        <TableNoData
          notFound={!data?.length}
          colSpan={4}
          emptyState={
            <EmptyState
              variant="plain"
              type="data"
              title="Sem matérias"
              text="Adicione alguma matéria"
            />
          }
        />
      </TableBody>
    </Table>
  );
}
